import { render, staticRenderFns } from "./AscRoleGridWrapper.vue?vue&type=template&id=80573720&"
import script from "./AscRoleGridWrapper.vue?vue&type=script&lang=js&"
export * from "./AscRoleGridWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports